/**
 * Line class contains a string representing the current line on a sign.
 */
import { Fonts } from 'domain-models/Fonts';
import { FontsService } from 'services/fonts/fonts.service';

export class Line {
	text: string = '';
	// Justifications should be used instead of text
	justifications: object = {};
	characterPixelCount: number = 0;
	// defaults to Font's lineSpacing value
	lineSpacing: number = undefined;
	foregroundColors: { color: string; text: string }[];
	maximunCharacter: number = 18;
	font: Fonts = new Fonts();
	isActive: boolean = false;

	setFont(id: number, fontsService: FontsService) {
		// Set font based on this id
		fontsService.getByValue(`${id}`, '').subscribe((result) => {
			this.font = result[0];
		});
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/libraries/Line.ts